const model = {
    arrayRoutes: null,
    error: null,
    loading: false
};
    
export default model;